module.exports = __webpack_public_path__ + "assets/img/nav.dd13b2dd.png";